import { BottomMenuBar } from "../../components/menu/bottom-menu.component/bottom-menu.component";
import { TopMenuBar } from "../../components/menu/top-menu.component/top-menu.component";
import { VersionIndicator } from "../../components/version-indicator/version-indicator.component";
import { SocialMediaFeed } from "../../feed/social_media_feed";
import { ExperimentBodyProps } from "../props";
import "./mobile-body.component.css";

export function MobileBody(props: ExperimentBodyProps) {
  return (
    <div className="experiment-body-container">
      <TopMenuBar
        notificationCount={5}
        branding={props.branding}
        controller={props.menuController}
        onlineUsers={props.onlineUsers}
      />
      <SocialMediaFeed
        posts={props.posts}
        driver={props.driver}
        testId={props.testId}
        onLikePostClicked={
          props.unsupportedFeatureController.onUnsupportedFeatureInvoked
        }
        onDislikePostClicked={
          props.unsupportedFeatureController.onUnsupportedFeatureInvoked
        }
        onSharePostClicked={
          props.unsupportedFeatureController.onUnsupportedFeatureInvoked
        }
        onCommentsClicked={
          props.unsupportedFeatureController.onUnsupportedFeatureInvoked
        }
        user={props.user}
      />
      <VersionIndicator experimentVersion={props.version} />
      <BottomMenuBar
        notificationCount={5}
        branding={props.branding}
        controller={props.menuController}
      />
    </div>
  );
}
